<template>
  <nx-linked-selectors
    v-validate="customValidation"
    :data-vv-name="name"
    :data-vv-scope="scope"
    :data-vv-as="label"
    data-vv-validate-on="input"
    :master="master"
    :slave="slave"
    :value="value"
    :error-messages="errorMessages"
    @input="onInput($event)"
    @focus="onFocus($event)"
    @blur="onBlur($event)"
    v-bind="$attrs"
  ></nx-linked-selectors>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import NxLinkedSelectors from '@/components/selectors/LinkedSelectors';
import get from 'lodash/get';
import isNil from 'lodash/isNil';

export default {
  name: 'nx-form-linked-selects',
  mixins: [FormElement],
  components: { NxLinkedSelectors },
  props: {
    master: {
      type: Object,
      required: true,
    },
    slave: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    empty() {
      return isNil(get(this.value, this.master.field, null))
        || isNil(get(this.value, this.slave.field, null));
    },
    customValidation() {
      if (!this.required) return this.validation;

      const customValidation = {
        nx_valid_linked_selects: [
          this.master.field,
          this.slave.field,
        ],
      };

      if (typeof this.validation === 'object') {
        return {
          ...this.validation,
          ...customValidation,
        };
      }

      if (typeof this.validation === 'string') {
        const params = customValidation.nx_valid_linked_selects.join(',');
        return `${this.validation}, nx_valid_linked_selects:${params}`;
      }

      return customValidation;
    },
  },
  methods: {
    onInput($event) {
      this.$emit('input', $event);
      this.$parentForm.updateField(this.name, $event);
    },
  },
};
</script>
